import styled from 'styled-components'

export const Divider = styled.hr`
  margin: 32px -24px;
  border-top: 8px solid var(--gray100);
`
